import { Component, OnInit } from '@angular/core';

import { SitemapCustomService } from './service/sitemap-custom.service';

@Component({
  selector: 'app-sitemap',
  templateUrl: './sitemap.component.html',
  styleUrls: ['./sitemap.component.scss']
})
export class SiteMapComponent implements OnInit {
  siteMapArray: any[] = [];

  constructor(private sitemapService: SitemapCustomService) {}

  ngOnInit(): void {
    this.getAllServices();
  }

  getAllServices() {
    this.sitemapService.getCategoryServices().subscribe((response) => {
      this.siteMapArray = response.data;
    });
  }

  getRouterUrl(text: string, sub_text: string) {
    let txt = '/category';
    if (sub_text) {
      txt += '/' + sub_text.toLowerCase().replace(/ /g, '-');
    }
    return txt + '/' + text.toLowerCase().replace(/ /g, '-');
  }

  checkSiteMapName(name: string) {
    return name.indexOf('(') > -1 || name.indexOf(')') > -1;
  }
}
